var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarousal1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3399,
    height: 3399,
    viewBox: "0 0 3399 3399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1785.14 2637.28H1365.75L1319.87 2998.82C1319.26 3003.56 1319.68 3008.37 1321.08 3012.94C1322.48 3017.51 1324.84 3021.74 1328 3025.33C1331.17 3028.92 1335.05 3031.81 1339.41 3033.76C1343.77 3035.73 1348.5 3036.77 1353.28 3036.77H1797.54C1802.34 3036.77 1807.06 3035.75 1811.43 3033.78C1815.8 3031.82 1819.69 3028.93 1822.85 3025.35C1826.03 3021.76 1828.39 3017.53 1829.78 3012.96C1831.19 3008.39 1831.62 3003.56 1831.01 2998.82L1785.14 2637.28Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M476.966 993.269H389.969C366.596 993.288 344.184 1002.58 327.655 1019.1C311.124 1035.63 301.824 1058.03 301.799 1081.41V2549.11C301.816 2572.48 311.11 2594.9 327.643 2611.43C344.174 2627.97 366.589 2637.27 389.969 2637.28H2760.77C2784.12 2637.25 2806.5 2627.97 2823.02 2611.47C2839.54 2594.97 2848.84 2572.6 2848.89 2549.25V1081.41C2848.87 1058.04 2839.58 1035.63 2823.06 1019.11C2806.52 1002.59 2784.12 993.292 2760.75 993.269H1279.93",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1758.42 1216.07H2848.89",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.799 1216.07H1568.15",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M779.783 1059.29C789.346 1059.29 798.693 1062.13 806.645 1067.44C814.596 1072.75 820.794 1080.3 824.453 1089.14C828.114 1097.97 829.07 1107.7 827.204 1117.07C825.338 1126.45 820.734 1135.07 813.972 1141.83C807.21 1148.59 798.595 1153.2 789.215 1155.06C779.836 1156.93 770.115 1155.97 761.281 1152.31C752.445 1148.65 744.894 1142.45 739.581 1134.5C734.267 1126.55 731.432 1117.21 731.432 1107.64C731.431 1101.29 732.68 1095 735.108 1089.14C737.537 1083.27 741.099 1077.94 745.589 1073.45C750.079 1068.96 755.411 1065.4 761.277 1062.97C767.144 1060.54 773.432 1059.29 779.783 1059.29Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M610.7 1059.29C620.263 1059.29 629.612 1062.13 637.562 1067.44C645.514 1072.75 651.711 1080.3 655.371 1089.14C659.03 1097.97 659.987 1107.7 658.121 1117.07C656.257 1126.45 651.651 1135.07 644.889 1141.83C638.128 1148.59 629.512 1153.2 620.132 1155.06C610.754 1156.93 601.031 1155.97 592.197 1152.31C583.362 1148.65 575.811 1142.46 570.498 1134.5C565.186 1126.55 562.349 1117.21 562.349 1107.64C562.344 1101.29 563.593 1095 566.02 1089.13C568.449 1083.27 572.011 1077.93 576.501 1073.44C580.991 1068.95 586.324 1065.39 592.192 1062.96C598.061 1060.53 604.349 1059.29 610.7 1059.29Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M441.615 1059.29C451.178 1059.29 460.527 1062.13 468.477 1067.44C476.429 1072.75 482.626 1080.3 486.286 1089.14C489.945 1097.97 490.902 1107.7 489.036 1117.07C487.172 1126.45 482.566 1135.07 475.804 1141.83C469.043 1148.59 460.427 1153.2 451.047 1155.06C441.669 1156.93 431.946 1155.97 423.112 1152.31C414.277 1148.65 406.726 1142.45 401.413 1134.5C396.101 1126.55 393.264 1117.21 393.264 1107.64C393.264 1094.82 398.359 1082.52 407.426 1073.45C416.493 1064.38 428.792 1059.29 441.615 1059.29Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1812.64 2065.69C1807.69 2057.47 1817.28 2051.62 1829.1 2055.87L1844.69 2015.56C1834 2003.66 1824.67 1992.71 1818.52 1984.3C1803.05 1963.13 1821.27 1950.6 1843.21 1964.49C1846.61 1966.68 1852.56 1970.72 1859.98 1975.97L1871.03 1947.37C1856.98 1924.6 1851.74 1905.99 1859.44 1899.79C1863.81 1896.22 1874.12 1899.99 1886.63 1906.99L1970.21 1690.65C1935.39 1677.5 1902.37 1659.96 1871.98 1638.45L1744.03 1742.38L1636.79 1636.86C1600.22 1665.91 1558.36 1687.58 1513.52 1700.67L1716.78 2346.58L1820.45 2078.22C1816.66 2072.39 1814.08 2068.1 1812.64 2065.69Z",
    fill: "#A7ECFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1886.67 1906.84L1970.25 1690.5C1935.41 1677.35 1902.4 1659.81 1872.02 1638.3L1744.06 1742.23L1636.82 1636.71C1600.25 1665.76 1558.39 1687.44 1513.56 1700.52L1716.82 2346.43L1820.49 2078.06",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1859.98 1975.97L1871.03 1947.37",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1829.1 2055.87L1844.69 2015.56",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1872.02 1638.32L1744.06 1742.24L1636.82 1636.72C1529.55 1730.09 1333.43 1719.33 1177.07 1826.2C977.858 1962.38 840.573 2323.51 755.326 2637.28H2547.09C2537.13 2501.32 2474.34 2194.31 2406.59 2021.56C2334.82 1838.54 2208.23 1759.03 2058.2 1719.04C1991.73 1703.73 1928.63 1676.37 1872.02 1638.32Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1524.25 1696.89C1569.59 1807.83 1620 1844.08 1620 1844.08L1744.06 1742.29L1865.12 1842.87C1903.93 1795.22 1937.33 1743.38 1964.64 1688.32",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1790.37 1780.77L1744.06 1742.29L1676.32 1797.87L1694.01 1851.38L1648.33 2128.86L1716.82 2346.5L1788.76 2160.3L1752.1 1851.74L1790.37 1780.77Z",
    fill: "#6095B3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1790.37 1780.77L1744.06 1742.29L1676.32 1797.87L1694.01 1851.38L1648.33 2128.86L1716.82 2346.5L1788.76 2160.3L1752.1 1851.74L1790.37 1780.77Z",
    stroke: "#6CA8C9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1984.29 1898.04L2084.76 1875.98L2087.05 1727.32",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1404.25 1732.2L1365.4 1877.42L1486.42 1889.33L1341.09 1971.67L1716.82 2346.5L1901.74 2165.62",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1716.82 2346.5V2635.18",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1674.18 1144.1C1597.36 1145.39 1572.84 1184.75 1554.12 1262.86C1534.7 1343.88 1527.66 1449.4 1565.1 1463.61C1602.54 1477.82 1663.52 1452.89 1704.75 1412.62C1711.99 1524.09 1689.56 1590.78 1636.77 1636.68L1744.01 1742.21L1871.97 1638.28C1835.87 1613.22 1807.66 1578.41 1790.63 1537.91C1770.4 1488.12 1761.06 1434.59 1763.2 1380.89C1803.22 1391.87 1829.04 1364.12 1821.93 1326.68C1814.83 1289.24 1772.88 1322.8 1772.88 1322.8C1782.62 1262.22 1750.99 1142.81 1674.18 1144.1Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2212.75 1044.82C2222.74 1035.66 2229.74 1023.7 2232.84 1010.49C2235.93 997.29 2234.96 983.461 2230.07 970.816C2225.17 958.171 2216.57 947.298 2205.39 939.618C2194.21 931.939 2180.99 927.811 2167.42 927.776C2165.72 927.776 2164.02 928.014 2162.32 928.014C2167.03 916.55 2168.49 904.008 2166.54 891.77C2164.59 879.53 2159.28 868.069 2151.23 858.647C2143.17 849.225 2132.69 842.209 2120.89 838.368C2109.11 834.529 2096.49 834.016 2084.44 836.886C2088.94 822.464 2088.45 806.95 2083.06 792.835C2077.69 778.721 2067.71 766.828 2054.75 759.066C2041.8 751.305 2026.6 748.128 2011.61 750.045C1996.62 751.962 1982.72 758.862 1972.13 769.637C1969.84 755.417 1963.04 742.311 1952.73 732.243C1942.43 722.177 1929.17 715.683 1914.89 713.715C1900.64 711.747 1886.11 714.412 1873.46 721.315C1860.82 728.219 1850.72 738.997 1844.67 752.064C1838.43 739.515 1828.42 729.226 1816.07 722.629C1803.7 716.033 1789.59 713.457 1775.69 715.262C1761.79 717.068 1748.8 723.163 1738.54 732.699C1728.26 742.236 1721.22 754.738 1718.4 768.465C1707.39 757.824 1693.09 751.254 1677.85 749.836C1662.61 748.421 1647.34 752.241 1634.56 760.671C1621.78 769.1 1612.26 781.634 1607.56 796.204C1602.87 810.774 1603.28 826.508 1608.73 840.812C1600.18 836.971 1590.91 834.997 1581.54 835.017C1568.31 835.048 1555.38 838.973 1544.37 846.305C1533.35 853.635 1524.74 864.046 1519.61 876.238C1514.47 888.431 1513.04 901.865 1515.49 914.865C1517.94 927.866 1524.17 939.856 1533.39 949.342C1518.07 947.22 1502.49 950.44 1489.27 958.464C1476.05 966.487 1466 978.824 1460.81 993.392C1455.62 1007.96 1455.61 1023.87 1460.78 1038.45C1465.95 1053.02 1475.99 1065.37 1489.2 1073.41C1476.78 1076.58 1465.52 1083.23 1456.75 1092.58C1447.98 1101.93 1442.07 1113.59 1439.7 1126.19C1437.33 1138.79 1438.61 1151.8 1443.39 1163.7C1448.17 1175.59 1456.24 1185.88 1466.67 1193.34C1455.26 1204.78 1448.35 1219.95 1447.2 1236.07C1446.06 1252.19 1450.75 1268.18 1460.42 1281.13C1470.09 1294.07 1484.09 1303.11 1499.88 1306.58C1515.66 1310.05 1532.16 1307.73 1546.37 1300.03C1548.6 1287.36 1551.2 1274.85 1554.07 1262.87C1572.77 1184.69 1597.31 1145.4 1674.12 1144.1C1750.94 1142.81 1782.57 1262.22 1772.88 1322.89C1772.88 1322.89 1814.85 1289.33 1821.93 1326.77C1829.02 1364.21 1803.24 1391.96 1763.2 1380.98C1761.31 1426.12 1767.65 1471.22 1781.89 1514.09C1789.1 1520.97 1797.75 1526.17 1807.21 1529.3C1816.66 1532.43 1826.71 1533.42 1836.6 1532.19C1846.49 1530.97 1855.99 1527.55 1864.4 1522.21C1872.81 1516.86 1879.94 1509.71 1885.24 1501.27C1894.74 1508.59 1906.02 1513.24 1917.94 1514.73C1929.83 1516.22 1941.92 1514.5 1952.93 1509.75C1963.94 1505 1973.49 1497.4 1980.58 1487.72C1987.67 1478.04 1992.03 1466.64 1993.24 1454.71C2003.03 1461.79 2014.54 1466.1 2026.57 1467.19C2038.6 1468.29 2050.7 1466.12 2061.6 1460.92C2072.49 1455.72 2081.79 1447.67 2088.52 1437.63C2095.23 1427.6 2099.12 1415.94 2099.77 1403.87C2113.28 1409.64 2128.32 1410.82 2142.56 1407.25C2156.82 1403.68 2169.51 1395.55 2178.71 1384.09C2187.92 1372.64 2193.12 1358.49 2193.53 1343.8C2193.94 1329.11 2189.55 1314.69 2181 1302.74C2196.28 1301.39 2210.64 1294.85 2221.69 1284.22C2232.73 1273.59 2239.82 1259.49 2241.76 1244.28C2243.7 1229.07 2240.38 1213.65 2232.34 1200.58C2224.31 1187.52 2212.05 1177.59 2197.61 1172.45C2211.71 1169.82 2224.61 1162.75 2234.42 1152.27C2244.22 1141.8 2250.43 1128.46 2252.13 1114.21C2253.81 1099.95 2250.9 1085.54 2243.82 1073.05C2236.73 1060.57 2225.85 1050.68 2212.75 1044.82Z",
    fill: "#6095B3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2212.75 1044.82C2222.74 1035.66 2229.74 1023.7 2232.84 1010.49C2235.93 997.29 2234.96 983.461 2230.07 970.816C2225.17 958.171 2216.57 947.298 2205.39 939.618C2194.21 931.939 2180.99 927.811 2167.42 927.776C2165.72 927.776 2164.02 928.014 2162.32 928.014C2167.03 916.55 2168.49 904.008 2166.54 891.77C2164.59 879.53 2159.28 868.069 2151.23 858.647C2143.17 849.225 2132.69 842.209 2120.89 838.368C2109.11 834.529 2096.49 834.016 2084.44 836.886C2088.94 822.464 2088.45 806.95 2083.06 792.835C2077.69 778.721 2067.71 766.828 2054.75 759.066C2041.8 751.305 2026.6 748.128 2011.61 750.045C1996.62 751.962 1982.72 758.862 1972.13 769.637C1969.84 755.417 1963.04 742.311 1952.73 732.243C1942.43 722.177 1929.17 715.683 1914.89 713.715C1900.64 711.747 1886.11 714.412 1873.46 721.315C1860.82 728.219 1850.72 738.997 1844.67 752.064C1838.43 739.515 1828.42 729.226 1816.07 722.629C1803.7 716.033 1789.59 713.457 1775.69 715.262C1761.79 717.068 1748.8 723.163 1738.54 732.699C1728.26 742.236 1721.22 754.738 1718.4 768.465C1707.39 757.824 1693.09 751.254 1677.85 749.836C1662.61 748.421 1647.34 752.241 1634.56 760.671C1621.78 769.1 1612.26 781.634 1607.56 796.204C1602.87 810.774 1603.28 826.508 1608.73 840.812C1600.18 836.971 1590.91 834.997 1581.54 835.017C1568.31 835.048 1555.38 838.973 1544.37 846.305C1533.35 853.635 1524.74 864.046 1519.61 876.238C1514.47 888.431 1513.04 901.863 1515.49 914.865C1517.94 927.866 1524.17 939.856 1533.39 949.342C1518.07 947.22 1502.49 950.44 1489.27 958.464C1476.05 966.487 1466 978.824 1460.81 993.392C1455.62 1007.96 1455.61 1023.87 1460.78 1038.45C1465.95 1053.02 1475.99 1065.37 1489.2 1073.41C1476.78 1076.58 1465.52 1083.23 1456.75 1092.58C1447.98 1101.93 1442.07 1113.59 1439.7 1126.19C1437.33 1138.79 1438.61 1151.8 1443.39 1163.7C1448.17 1175.59 1456.24 1185.88 1466.67 1193.34C1455.26 1204.78 1448.35 1219.95 1447.2 1236.07C1446.06 1252.19 1450.75 1268.18 1460.42 1281.13C1470.09 1294.07 1484.09 1303.11 1499.88 1306.58C1515.66 1310.05 1532.16 1307.73 1546.37 1300.03C1548.6 1287.36 1551.2 1274.85 1554.07 1262.87C1572.77 1184.69 1597.31 1145.4 1674.12 1144.1C1750.94 1142.81 1782.57 1262.22 1772.88 1322.89C1772.88 1322.89 1814.85 1289.33 1821.93 1326.77C1829.02 1364.21 1803.24 1391.96 1763.2 1380.98C1761.31 1426.11 1767.65 1471.21 1781.89 1514.09C1789.1 1520.97 1797.75 1526.17 1807.21 1529.3C1816.66 1532.43 1826.71 1533.42 1836.6 1532.19C1846.49 1530.97 1855.99 1527.55 1864.4 1522.21C1872.81 1516.86 1879.94 1509.71 1885.24 1501.27C1894.74 1508.59 1906.02 1513.24 1917.94 1514.73C1929.83 1516.22 1941.92 1514.5 1952.93 1509.75C1963.94 1505 1973.49 1497.4 1980.58 1487.72C1987.67 1478.04 1992.03 1466.64 1993.24 1454.71C2003.03 1461.79 2014.54 1466.1 2026.57 1467.19C2038.6 1468.29 2050.7 1466.12 2061.6 1460.92C2072.49 1455.72 2081.79 1447.67 2088.52 1437.63C2095.23 1427.6 2099.12 1415.93 2099.77 1403.87C2113.28 1409.64 2128.32 1410.82 2142.56 1407.25C2156.82 1403.68 2169.51 1395.55 2178.71 1384.09C2187.92 1372.64 2193.12 1358.49 2193.53 1343.8C2193.94 1329.11 2189.55 1314.69 2181 1302.74C2196.28 1301.39 2210.64 1294.85 2221.69 1284.22C2232.73 1273.59 2239.82 1259.49 2241.76 1244.28C2243.7 1229.07 2240.38 1213.65 2232.34 1200.58C2224.31 1187.52 2212.05 1177.59 2197.61 1172.45C2211.71 1169.82 2224.61 1162.75 2234.42 1152.27C2244.22 1141.8 2250.43 1128.46 2252.13 1114.21C2253.81 1099.95 2250.9 1085.54 2243.82 1073.05C2236.73 1060.57 2225.85 1050.68 2212.75 1044.82Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1996.33 2244.85L2314.7 2143.56C2297.15 2096.89 2272.54 2053.18 2241.73 2013.98C2194.6 1950.4 2133.4 1907.54 2115.72 1909.58C2096.72 1911.77 2089.04 1937.01 2107.33 1965.88C2122.47 1987.12 2140.71 2005.97 2161.42 2021.83C2161.42 2021.83 2020.67 1923.1 1999.46 1908.11C1929.87 1858.93 1906.96 1880.92 1974.24 1954.92C1996.16 1979.05 2054.3 2037.17 2054.3 2037.17C2054.3 2037.17 1977.83 1968.07 1953.39 1951.99C1928.95 1935.92 1871.51 1889.83 1859.44 1899.7C1847.37 1909.58 1867.1 1949.8 1902.95 1988.91C1928.17 2015.86 1954.76 2041.49 1982.64 2065.69C1982.64 2065.69 1865.15 1978.37 1843.28 1964.49C1821.4 1950.6 1803.12 1963.13 1818.58 1984.3C1853.1 2025.35 1889.71 2064.59 1928.24 2101.89C1928.24 2101.89 1846.66 2064.96 1833.18 2057.7C1819.71 2050.45 1807.21 2056.6 1812.79 2065.74C1832.5 2097.78 1856.86 2126.74 1885.02 2151.69C1928.93 2191.61 1969.89 2199.03 1996.33 2244.85Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2481.68 2453.84L2336.88 2136.49L1947.13 2260.56C1967.94 2363.77 2093.48 2596.38 2108.89 2639.54",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.53 1145.17C1226.99 1100.48 1261.03 1046.51 1282.19 987.12H1015.78C975.333 1024.35 931.214 1057.38 884.099 1085.69C836.521 1057.28 791.848 1024.26 750.722 987.12H474.74C493.929 1040.7 523.577 1089.94 561.963 1131.96C600.348 1173.98 646.706 1207.95 698.338 1231.89C749.971 1255.84 805.847 1269.28 862.721 1271.44C919.594 1273.59 976.329 1264.42 1029.63 1244.46L1219.39 1332.19C1219.68 1332.33 1220.01 1332.39 1220.34 1332.36C1220.66 1332.33 1220.97 1332.2 1221.22 1331.99C1221.48 1331.79 1221.67 1331.52 1221.77 1331.21C1221.87 1330.9 1221.89 1330.57 1221.81 1330.25L1182.53 1145.17Z",
    fill: "#A7ECFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.92 843.511C1306.9 752.202 1277.71 663.289 1223.6 589.74C1169.49 516.191 1093.3 461.856 1006.13 434.659C918.971 407.464 825.398 408.828 739.065 438.558C652.732 468.287 578.158 524.823 526.22 599.92C474.281 675.016 447.696 764.744 450.344 856.014C452.992 947.283 484.733 1035.32 540.937 1107.28C597.142 1179.24 674.87 1231.36 762.78 1256.03C850.69 1280.7 944.186 1276.64 1029.63 1244.44L1219.39 1332.19C1219.68 1332.33 1220.01 1332.39 1220.34 1332.36C1220.66 1332.32 1220.97 1332.2 1221.22 1331.99C1221.48 1331.79 1221.67 1331.52 1221.77 1331.21C1221.87 1330.9 1221.89 1330.56 1221.8 1330.25L1182.53 1145.17C1262.27 1065.04 1307 956.56 1306.92 843.511Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M750.722 987.104H474.74",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1282.19 987.104H1015.77",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3204.1 1263.48V1339.02",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M3204.1 1438.57V1514.11",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M3095.57 1451.44L3161 1413.68",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M3247.22 1363.9L3312.63 1326.14",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3312.63 1451.44L3247.22 1413.68",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3161 1363.9L3095.57 1326.14",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M312.385 2663.59V2739.12",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M312.385 2838.67V2914.22",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M203.855 2851.56L269.286 2813.79",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M355.484 2764.02L420.915 2726.24",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M420.915 2851.56L355.484 2813.79",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M269.286 2764.02L203.855 2726.24",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.04 353.294V487.639",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.21 420.477H1193.88",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2315.72 2801.68V2964.83",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2397.3 2883.25H2234.15",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2400.71 784.968C2428.33 784.968 2450.71 762.583 2450.71 734.969C2450.71 707.356 2428.33 684.97 2400.71 684.97C2373.1 684.97 2350.71 707.356 2350.71 734.969C2350.71 762.583 2373.1 784.968 2400.71 784.968Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M167.213 1951.18C209.103 1951.18 243.062 1917.22 243.062 1875.33C243.062 1833.44 209.103 1799.48 167.213 1799.48C125.323 1799.48 91.3647 1833.44 91.3647 1875.33C91.3647 1917.22 125.323 1951.18 167.213 1951.18Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.71 2637.28L1086.92 1807.74L474.296 1940.49L625.263 2637.28H1266.71Z",
    fill: "#A7ECFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.71 2637.28L1086.92 1807.74L474.296 1940.49L625.263 2637.28H1266.71Z",
    fill: "#A7ECFF",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M624.515 1907.94L915.13 1845.06L907.295 1808.96C907.118 1808.12 906.777 1807.3 906.286 1806.59C905.796 1805.87 905.169 1805.26 904.44 1804.78C903.712 1804.31 902.897 1803.99 902.042 1803.83C901.187 1803.66 900.308 1803.68 899.459 1803.87L621.83 1864.03C620.977 1864.22 620.17 1864.56 619.451 1865.05C618.732 1865.54 618.118 1866.17 617.644 1866.9C617.172 1867.63 616.845 1868.45 616.689 1869.3C616.533 1870.15 616.546 1871.03 616.732 1871.88L624.515 1907.94Z",
    fill: "#A7ECFF",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M712.955 1844.23L803.284 1824.65C802.38 1819.08 800.349 1813.74 797.317 1808.98C794.283 1804.22 790.313 1800.13 785.646 1796.95C780.98 1793.77 775.715 1791.56 770.171 1790.49C764.629 1789.4 758.923 1789.47 753.403 1790.66L744.294 1792.63C738.776 1793.84 733.558 1796.13 728.96 1799.41C724.361 1802.69 720.477 1806.87 717.546 1811.7C714.612 1816.53 712.694 1821.9 711.905 1827.49C711.116 1833.08 711.473 1838.79 712.955 1844.23Z",
    fill: "#A7ECFF",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M649.192 2123.05L996.876 2047.69Z",
    fill: "#A7ECFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M649.192 2123.05L996.876 2047.69",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M673.427 2217.92L1021.13 2142.56Z",
    fill: "#A7ECFF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M673.427 2217.92L1021.13 2142.56",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M697.679 2312.76L1045.36 2237.43Z",
    fill: "#A7ECFF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M697.679 2312.76L1045.36 2237.43",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M721.912 2407.63L1069.61 2332.29Z",
    fill: "#A7ECFF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M721.912 2407.63L1069.61 2332.29",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M746.164 2502.5L1093.85 2427.16Z",
    fill: "#A7ECFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M746.164 2502.5L1093.85 2427.16",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.55 722.291C1088.97 704.633 1070.58 691.275 1049.59 683.824C1028.6 676.376 1005.9 675.15 984.231 680.296C940.401 692.295 905.664 730.788 881.327 769.129C856.99 730.788 825.651 692.261 781.889 680.143C760.21 675.036 737.518 676.28 716.526 683.727C695.536 691.175 677.133 704.509 663.519 722.138C622.867 774.703 616.919 854.172 712.447 950.755C763.822 1002.72 821.484 1048.07 884.097 1085.75C946.044 1048.05 1003.02 1002.74 1053.69 950.874C1148.1 855.294 1143.12 774.703 1102.55 722.291Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M650.893 866.22H819.28L845.52 803.304L886.903 1023.34L925.923 847.712H1122.23",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousal1);
export default __webpack_public_path__ + "static/media/Carousal_1.c19d5f5cdc2d9426b634603402002268.svg";
export { ForwardRef as ReactComponent };